module.exports = __webpack_public_path__ + "img/ic_bluepeople copy 2.30354ed6.svg";